export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-J1-J2.0aa4479a.jpg";